(function iefe(w, d) {
    function createSideCollapsibles() {
        const collapsibles = d.querySelectorAll('.SideNavItem__details');
        collapsibles.forEach((collapsible) => {
            const heading = collapsible.querySelector('.SideNavItem__summary');
            if (!heading) {
                return;
            }
            const button = d.createElement('button');
            const content = heading.innerHTML;
            const open = collapsible.classList.contains('SideNavItem__details--open') ? 'true' : 'false';
            const id = collapsible.querySelector('.SideNavItem__content').getAttribute('id');
            collapsible.classList.remove('SideNavItem__details--init');
            button.setAttribute('aria-expanded', open);
            button.classList.add('SideNavItem__summary-button');
            if (id) {
                button.setAttribute('aria-controls', id);
            }
            button.innerHTML = content;
            heading.innerHTML = '';
            heading.appendChild(button);

            heading.addEventListener('click', () => {
                const isopen = button.getAttribute('aria-expanded');
                if (isopen === 'true') {
                    collapsible.classList.remove('SideNavItem__details--open');
                    button.setAttribute('aria-expanded', 'false');
                } else {
                    collapsible.classList.add('SideNavItem__details--open');
                    button.setAttribute('aria-expanded', 'true');
                }
            });
        });
    }

    createSideCollapsibles();
}(window, document));
